import React, {useMemo} from "react";
import {useAuth} from "./AuthProvider";


let ClientContext = React.createContext(null);

const ClientProvider = ({children, criteria, talent,onUpdated,...props}) => {


    const {auth} = useAuth();

    const clientOrg = useMemo(() => {
        if (!auth || !auth.clientOrg()) {
            return null
        }

        return auth.clientOrg();
    },[auth, auth.clientOrg?.()?.id])

    return (
        <ClientContext.Provider value={clientOrg}>
            {children}
        </ClientContext.Provider>
    );
}

const useClient = () => {
    return React.useContext(ClientContext);
}
export default ClientProvider;
export {
    useClient,
    ClientContext
}